module.exports = __webpack_public_path__ + "img/10_of_Hearts.svg.08f5c14d.png";